"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _invoiceRecord = require("@/api/invoiceRecord");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InvoiceRecordForm',
  data: function data() {
    return {
      dialogVisible: false,
      dialogTitle: '新增发票记录',
      formLoading: false,
      submitLoading: false,
      formType: 'create',
      showUploadDialog: false,
      uploadedFileUrl: '',
      formData: {
        id: undefined,
        invoiceCode: '',
        orderNo: '',
        invoiceAmount: 0,
        invoiceType: 0,
        category: 1,
        invoiceTitle: '',
        taxNo: '',
        status: 0,
        applyTime: '',
        spuId: 0,
        invoiceTime: '',
        companyName: '',
        companyAddress: '',
        companyPhone: '',
        bankName: '',
        bankAccount: '',
        email: '',
        orderId: 0,
        userId: 0,
        userName: '',
        spuName: '',
        attachmentUrl: '',
        remark: ''
      },
      formRules: {
        orderNo: [{
          required: true,
          message: '订单号不能为空',
          trigger: 'blur'
        }],
        orderId: [{
          required: true,
          message: '订单ID不能为空',
          trigger: 'blur'
        }],
        invoiceAmount: [{
          required: true,
          message: '开票金额不能为空',
          trigger: 'blur'
        }],
        invoiceType: [{
          required: true,
          message: '开票类型不能为空',
          trigger: 'change'
        }],
        category: [{
          required: true,
          message: '发票类别不能为空',
          trigger: 'change'
        }],
        invoiceTitle: [{
          required: true,
          message: '发票抬头不能为空',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '发票状态不能为空',
          trigger: 'change'
        }],
        email: [{
          type: 'email',
          message: '请输入正确的邮箱格式',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    /** 确认上传文件 */confirmUploadFile: function confirmUploadFile() {
      if (this.uploadedFileUrl) {
        this.formData.attachmentUrl = this.uploadedFileUrl;
        this.showUploadDialog = false;
        this.uploadedFileUrl = '';
        this.$message.success('附件上传成功');
      }
    },
    /** 打开图片选择 */modalPicTap: function modalPicTap() {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.uploadedFileUrl = img[0].sattDir;
      }, false, 'store');
    },
    /** 打开弹窗 */open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type, id) {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.dialogVisible = true;
              this.dialogTitle = type === 'create' ? '新增发票记录' : '修改发票记录';
              this.formType = type;
              this.resetForm();
              // 修改时，设置数据
              if (!id) {
                _context.n = 4;
                break;
              }
              this.formLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _invoiceRecord.getInvoiceRecordDetail)(id);
            case 2:
              res = _context.v;
              this.formData = _objectSpread(_objectSpread({}, this.formData), res);
            case 3:
              _context.p = 3;
              this.formLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function open(_x, _x2) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    /** 提交表单 */submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this2.submitLoading = true;
                _context2.p = 2;
                _context2.n = 3;
                return (0, _invoiceRecord.createOrUpdateInvoiceRecord)(_this2.formData);
              case 3:
                _this2.$message.success(_this2.formType === 'create' ? '新增成功' : '修改成功');
                _this2.dialogVisible = false;
                _this2.$emit('success');
              case 4:
                _context2.p = 4;
                _this2.submitLoading = false;
                return _context2.f(4);
              case 5:
                return _context2.a(2);
            }
          }, _callee2, null, [[2,, 4, 5]]);
        }));
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    /** 重置表单 */resetForm: function resetForm() {
      this.formData = {
        id: undefined,
        invoiceCode: '',
        orderNo: '',
        invoiceAmount: 0,
        invoiceType: 0,
        category: 1,
        invoiceTitle: '',
        taxNo: '',
        status: 0,
        applyTime: '',
        spuId: 0,
        invoiceTime: '',
        companyName: '',
        companyAddress: '',
        companyPhone: '',
        bankName: '',
        bankAccount: '',
        email: '',
        orderId: 0,
        userId: 0,
        userName: '',
        spuName: '',
        attachmentUrl: '',
        remark: ''
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    handleClose: function handleClose() {
      this.resetForm();
    }
  }
};